import React, { useEffect, useRef } from "react";
import "./LoaderMj.css";
import LoaderIconMj from "./LoaderIconMj";
import generateID from "../../../../utils/string-utils";
var LoaderMj = function (props) {
    var noId = props.noId, id = props.id, color = props.color, children = props.children;
    var _Id = useRef(id || generateID());
    useEffect(function () {
        _Id.current = id || generateID();
    }, [id]);
    return (React.createElement("div", { id: noId ? undefined : _Id.current, className: "loaderContent dsmj-specifique-loader" },
        React.createElement("div", { className: "loaderContainer" },
            React.createElement(LoaderIconMj, { fill: color, className: "loaderContainer loaderAnimationCircle1Linear" }),
            React.createElement(LoaderIconMj, { fill: color, className: "loaderContainer loaderAnimationCircle2Linear" }),
            React.createElement(LoaderIconMj, { fill: color, className: "loaderContainer loaderAnimationCircle3Linear" })),
        children && (React.createElement("div", { className: "labelLogo" }, children))));
};
export default LoaderMj;
